module.exports = __webpack_public_path__ + "img/trailer (2).64af388e.jpg";